import { Link as RouterLink } from 'react-router-dom';
import { Box, Breadcrumbs, Grid, Link, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import './TopHeaderContainer.component.css';
import { TopHeaderContainerProps } from './types';
import { useMemo } from 'react';
import SelectionToolbox from './SelectionToolbox';

export default function TopHeaderContainer({
    title = '',
    subtitle = '',
    firstColChildren = null,
    children = null,
    selection = [],
    selectionRef,
    apiCall,
    parent = undefined,
    selectionRoutes = {},
    additionalButtons,
    childrenSx,
}: TopHeaderContainerProps) {
    const theme = useTheme();

    const headerClassName = [
        'headerBackdrop',
        theme.palette.mode === 'dark' ? 'dark' : 'light',
    ].join(' ');

    return useMemo(() => {
        return (
            <Grid
                item
                xs={12}
                sx={{ position: 'sticky', top: 40, zIndex: 3, mt: 0 }}>
                <Box flexGrow={1} sx={{ position: 'relative' }}>
                    <Box className={headerClassName} />
                    <Grid
                        container
                        direction="row"
                        spacing={2}
                        sx={{ p: 2, minHeight: 110 }}
                        alignItems="center">
                        <Grid
                            item
                            flexGrow={1}
                            sx={{ display: 'flex', alignItems: 'center' }}>
                            <Stack flex={1}>
                                {parent && (
                                    <Breadcrumbs>
                                        {parent.map((parentPage, pageIndex) => (
                                            <Link
                                                key={`page-${pageIndex}`}
                                                underline="hover"
                                                color="inherit"
                                                component={RouterLink}
                                                to={parentPage.path}>
                                                {parentPage.name}
                                            </Link>
                                        ))}
                                        <Typography color="text.primary">
                                            {title}
                                        </Typography>
                                    </Breadcrumbs>
                                )}
                                <Typography
                                    variant="h4"
                                    sx={{ lineHeight: 1.8 }}>
                                    {title}
                                </Typography>
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="flex-start"
                                    flexWrap="wrap"
                                    width="100%">
                                    {subtitle && (
                                        <Typography
                                            variant="caption"
                                            lineHeight={1}
                                            sx={{
                                                minHeight: 40,
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                            className={'cutTextEnd'}>
                                            {subtitle}
                                        </Typography>
                                    )}
                                    <SelectionToolbox
                                        selection={selection}
                                        selectionRef={selectionRef}
                                        apiCall={apiCall}
                                        routes={selectionRoutes}
                                        additionalButtons={additionalButtons}
                                    />
                                </Stack>
                            </Stack>
                            {firstColChildren}
                        </Grid>
                        {children && (
                            <Grid item sx={childrenSx}>
                                {children}
                            </Grid>
                        )}
                    </Grid>
                </Box>
            </Grid>
        );
    }, [
        title,
        subtitle,
        firstColChildren,
        children,
        childrenSx,
        selection,
        selectionRef,
        theme,
    ]);
}
